import { connect, ConnectedProps } from "react-redux";
import { CorpRoomProduct } from "redmond";
import {
  updateUserPassenger,
  deleteUserPassenger,
  fetchUserPassengers,
  setUserSelectedPassengerIds,
  fetchCorpUserPassengers,
} from "../../../actions/actions";
import {
  getHotelBookChosenProduct,
  getHotelBookSelectedAvailabilityCheckInMinimumAge,
  getRoomsCountInBook,
  getUserPassengerCallState,
  getUserPassengers,
  getUserSelectedTravelerIds,
  getFromDateInBook,
} from "../../../reducer";
import { IStoreState } from "../../../../../reducers/types";
import { getCorporateInfo } from "../../../../rewards/reducer/selectors";
import { MobileHotelBookPassengerSelection } from "./component";

const mapStateToProps = (state: IStoreState) => {
  return {
    travelers: getUserPassengers(state),
    userPassengerCallState: getUserPassengerCallState(state),
    selectedTravelerIds: getUserSelectedTravelerIds(state),
    roomsCount: getRoomsCountInBook(state),
    chosenProduct: getHotelBookChosenProduct(state) as CorpRoomProduct,
    minimumCheckInAge:
      getHotelBookSelectedAvailabilityCheckInMinimumAge(state),
    checkInDate: getFromDateInBook(state),
    userRoles: getCorporateInfo(state)?.role,
  };
};

const mapDispatchToProps = {
  updateUserPassenger,
  setUserSelectedPassengerIds,
  deleteUserPassenger,
  fetchUserPassengers,
  fetchCorpUserPassengers,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileHotelBookPassengerSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileHotelBookPassengerSelection = connector(
  MobileHotelBookPassengerSelection
);
